const afterTaxDiscountCalculateTotal = (quantity, price, sellingGST, discount) => {
    console.log({ quantity, price, sellingGST, discount });
    let total = quantity * price
    let gstAmount = total * (sellingGST / 100);
    let totalAmount = total + gstAmount;
    let discountAmount = totalAmount * (discount / 100);
    return totalAmount - discountAmount;
}

const beforeTaxDiscountCalculateTotal = (quantity, price, sellingGST, discount) => {
    let total = quantity * price
    let discountAmount = total * (discount / 100);
    let afterDiscountTotal = total - discountAmount;
    let gstAmount = afterDiscountTotal * (sellingGST / 100);

    return afterDiscountTotal + gstAmount;
}

const withoutTaxCalculate = (quantity, price, discount) => {
    let total = quantity * price;
    let discountAmount = total * (discount / 100);
    return total - discountAmount;
}

const withoutTaxAndDiscountCalculate = (quantity, price) => {
    return quantity * price;
}

export {
    afterTaxDiscountCalculateTotal,
    beforeTaxDiscountCalculateTotal,
    withoutTaxCalculate,
    withoutTaxAndDiscountCalculate
}